import { UsersState } from "../../types";

export const initUsersState: UsersState = {};
